export default "__VITE_ASSET__Dq3QgTZ4__"